export const LOGO_SRC = "/assets/corex-logo-white.png";
